import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { api } from '../lib/api';

export function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      navigate('/login?reset=1');
    } catch (err: any) {
      setError(err.response?.data?.error ?? 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-base">
        <div className="card w-[400px] p-8 text-center space-y-4">
          <p className="text-sm text-danger">Invalid reset link.</p>
          <Link to="/forgot-password" className="btn-primary block">Request a new one</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-base">
      <form onSubmit={submit} className="card w-[400px] p-8 space-y-4">
        <div className="text-center mb-2">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center font-bold text-white">Cr</div>
            <div className="text-lg font-semibold tracking-tight">Cros<span className="text-secondary-400">ova</span></div>
          </div>
          <h1 className="text-lg font-semibold">Choose a new password</h1>
          <p className="text-xs text-white/40 mt-1">Must be at least 8 characters</p>
        </div>
        <input
          className="input"
          placeholder="New password"
          type="password"
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          className="input"
          placeholder="Confirm new password"
          type="password"
          minLength={8}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        {error && <p className="text-xs text-orange-400">{error}</p>}
        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? 'Saving...' : 'Set new password'}
        </button>
      </form>
    </div>
  );
}
